import approve from 'approvejs'

// Add the test "numericGreaterThanZero" to ApproveJs
var numericGreaterThanZero = {
  regex: /^[0-9]+$/,
  validate : function (value) {
    return this.regex.test(value) && parseInt(value) !== 0;
  },
  message : '{title} must be greater than zero.',
  expects : false
};
approve.addTest(numericGreaterThanZero, 'numericGreaterThanZero');

export function validateValue(value, field) {
  let result = approve.value(value, field.rules)

  if (result.errors && result.errors.length > 0) {
    field = Object.assign({}, field, {
      errors: Array.from(result.errors),
      value: ''
    })
  } else {
    field = Object.assign({}, field, {
      errors: [],
      value: value
    })
  }
  
  return field;
}

export function validateField(field) {
  let result = approve.value(field.value, field.rules)

  if (result.errors && result.errors.length > 0) {
    field = Object.assign({}, field, {
      errors: Array.from(result.errors),
      value: ''
    })
  } else {
    field = Object.assign({}, field, {
      errors: []
    })
  }
  
  return field
}